const CLIENT_PRIMARY_STYLE_ID = 'core-widget-client-primary-colors'
const CLIENT_STYLESHEET_ID = 'core-widget-client-stylesheet'
const HEX_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/

type RgbColor = {
  r: number
  g: number
  b: number
}

function hexToRgb(hexColor: string): RgbColor {
  return {
    r: Number.parseInt(hexColor.slice(1, 3), 16),
    g: Number.parseInt(hexColor.slice(3, 5), 16),
    b: Number.parseInt(hexColor.slice(5, 7), 16),
  }
}

function rgbToHex(color: RgbColor): string {
  const toHex = (value: number) => Math.round(value).toString(16).padStart(2, '0')
  return `#${toHex(color.r)}${toHex(color.g)}${toHex(color.b)}`
}

function mixColors(base: RgbColor, target: RgbColor, targetWeight: number): string {
  const baseWeight = 1 - targetWeight
  return rgbToHex({
    r: base.r * baseWeight + target.r * targetWeight,
    g: base.g * baseWeight + target.g * targetWeight,
    b: base.b * baseWeight + target.b * targetWeight,
  })
}

function buildPrimaryColorCss(primaryColor: string): string {
  const base = hexToRgb(primaryColor)
  const white = { r: 255, g: 255, b: 255 }
  const black = { r: 0, g: 0, b: 0 }

  return `
:root {
  --color-primary-light: ${mixColors(base, white, 0.88)};
  --color-primary-medium: ${mixColors(base, white, 0.22)};
  --color-primary-default: ${primaryColor};
  --color-primary-dark: ${mixColors(base, black, 0.14)};
}
`.trim()
}

export function applyClientPrimaryColor(primaryColor: string | null | undefined) {
  document.getElementById(CLIENT_PRIMARY_STYLE_ID)?.remove()

  if (!primaryColor || !HEX_COLOR_PATTERN.test(primaryColor)) {
    return
  }

  const style = document.createElement('style')
  style.id = CLIENT_PRIMARY_STYLE_ID
  style.textContent = buildPrimaryColorCss(primaryColor)
  document.head.appendChild(style)
}

export function loadClientStylesheet(origin: string, cssPath: string | null | undefined) {
  document.getElementById(CLIENT_STYLESHEET_ID)?.remove()

  if (!cssPath) {
    return
  }

  const href = cssPath.startsWith('http') ? cssPath : origin + cssPath
  const cssLink = document.createElement('link')
  cssLink.id = CLIENT_STYLESHEET_ID
  cssLink.setAttribute('href', href)
  cssLink.setAttribute('rel', 'stylesheet')
  cssLink.setAttribute('type', 'text/css')
  document.head.appendChild(cssLink)
}
